<template>
	<div>
		<v-data-table hide-headers disable-initial-sort :headers="headers" :items="departments" hide-actions class="elevation-1">
			<template slot="items" slot-scope="props">
				<tr>
					<td class="text-xs-left">{{ props.item.name }}</td>
					<td class="justify-center px-0">
						<v-icon small class="mr-2" @click="editDepartment(props.item)">
							edit
						</v-icon>
						<v-icon small @click="deleteDepartment(props.item)">
							delete
						</v-icon>
					</td>
				</tr>
			</template>
		</v-data-table>
	</div>
</template>

<script>
	import DepartmentEditor from '@/components/DepartmentEditor';

	export default {
		components: {
			DepartmentEditor
		},
		props: {
			departments: {
				required: true,
				type: Array
			}
		},
		data() {
			return {
				headers: [
					{ text: 'Name', value: 'name' },
					{ text: '', value: 'actions', sortable: false }
				]
			};
		},
		methods: {
			editDepartment(item) {
				this.$emit('onEditDepartment', item);
			},
			deleteDepartment(item) {
				this.$emit('onDeleteDepartment', item);
			}
		}
	};
</script>

<style></style>
